import { isRouteErrorResponse, useRouteError } from 'react-router';

/** Router errorElement. Rendered outside providers, so it uses only plain elements. */
export function RootErrorPage() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-xl flex-col items-start justify-center gap-4 px-4">
      <h1 className="m-0 font-display text-display-lg font-semibold">
        {notFound ? 'Page not found' : 'Something went wrong'}
      </h1>
      <p className="m-0 text-base text-ink-soft">
        {notFound
          ? 'That page does not exist.'
          : 'Reload the page to try again. Code you wrote is saved on this device.'}
      </p>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="min-h-11 cursor-pointer rounded-md border-0 bg-accent px-[18px] font-semibold text-white hover:bg-accent-hover"
        >
          Reload
        </button>
        <a
          href="/"
          className="flex min-h-11 items-center rounded-md border border-line-strong bg-surface px-[18px] font-medium text-ink no-underline"
        >
          Go home
        </a>
      </div>
    </main>
  );
}
